/**
 * Pestaña inicial de /aseos para la ASEADORA en celular (round 2026-10-26).
 *
 * El default de siempre es «Aseos abiertos» ("1"). Pero la aseadora que ya tiene
 * aseos asignados casi siempre viene a ver ESOS («Aseos por hacer», "2"), y en un
 * celular esa pestaña ni siquiera se alcanzaba: aterrizaba en «Aseos abiertos (0)»
 * y veía «No hay datos». Solo se decide una vez, con la primera carga, y solo si
 * ella no tocó ninguna pestaña antes. Escritorio y admin no pasan por acá.
 *
 * Devuelve la pestaña a la que hay que saltar, o `null` para dejar la que está.
 */
export type ClavePestanaAseos = "1" | "2" | "3";

export function pestanaInicialAseadora(p: {
  /** Aseos pendientes / en proceso asignados a ella (pestaña «por hacer»). */
  porHacer: number;
  /** Pestaña que está activa ahora. */
  actual: ClavePestanaAseos;
  /** ¿Ella ya eligió una pestaña a mano? Entonces no se le cambia. */
  eligioAMano: boolean;
}): ClavePestanaAseos | null {
  if (p.eligioAMano) return null;
  if (p.actual !== "1") return null;
  return p.porHacer > 0 ? "2" : null;
}
